// $form is the parent element containing the inputs desired to be validated
// obj is the validation object allowing for further validation specification, callbacks, etc
// Look at adding dirty flag on focus.
function validate_mini_form($form, obj = 'input, select'){
	var inputs = $form.find(obj.types);
    var validArray = []; 

	inputs.each(function(){
        const $input = am.$(this);

        if($input.attr('data-validation')){
            var passed;
            var validationObj = createObjectFromString($input.attr('data-validation'));
            validationObj.input = $input;

            if ($input.val() == '' && $input.attr('data-placeholder') && $input.attr('data-placeholder') == $input.attr('data-prev_state') && !$input.hasClass('is_new')){
                $input.val($input.attr('data-placeholder'));
            }

            if(validationObj.required){
                if($input.val() == '' || $input.val() == ' '){
                    passed = false;
                    validationObj.passed = passed;
                    validationObj.errorMsg = validationObj.type == 'number' ? (validationObj.positive ? "Positive value only" : "This field requires a number") : "Required field";
                    handle_passed_fail(validationObj);
                }else if(validationObj.minLength && validationObj.type != 'number'){
                    passed = check_min_length(validationObj)
                    validationObj.passed = passed;
                    validationObj.errorMsg = "Minimum " + validationObj.type + " Length of " + validationObj.minLength + " required";
                    handle_passed_fail(validationObj);
                }
                else{
                    if(validationObj.type == 'number'){
                        if(validationObj.decimal)
                            var round = decimal_check($input.val(), validationObj.decimal);
                        else
                            var round = decimal_check($input.val());

                        if(validationObj.positive){
                            validationObj.errorMsg = "Value greater than 0 required";
                            passed = isPositive( round );
                        }
                        else
                            passed = isNumber( parseInt( round ) );
                    }
                    else if (validationObj.type == 'text'){
                        passed = check_text_valid(validationObj);
                    }

                    validationObj.passed = passed;
                    handle_passed_fail( validationObj );
                }
            }
        }
        
        validArray.push( passed );
    })

    return validArray.includes(false) ? false : true;
}

function process_awaiting_validation(validationObj){
    let v = '';
    if(validationObj.type == 'number'){
       v = 0;
    }

    // validationObj.input.addEventListener('click', () => {
    //     validationObj.input.addClass('awaitingvalue');
    // });

    if(validationObj.input.attr('data-prev_state') == v && validationObj.input.attr("data-value") == v && validationObj.input.val() == v && !validationObj.input.hasClass('am-error-border')){
        validationObj.input.addClass('awaitingvalue');
    }else if(validationObj.input.hasClass('awaitingvalue') && validationObj.input.val() != v || validationObj.input.hasClass('am-error-border')){
        validationObj.input.removeClass('awaitingvalue');
    }
}

function createObjectFromString( str ) {
    var obj = {};
  
    // Remove leading and trailing braces from the string
    str = str.slice(1, -1);
  
    // Split the string by commas to get individual key-value pairs
    var pairs = str.split(',');
  
    // Iterate over the pairs and parse them into the object
    pairs.forEach(function(pair) {
        // Split each pair into key and value
        var keyValue = pair.split(':');
  
        // Remove any leading/trailing spaces from the key and value
        var key = keyValue[0].trim();
        var value = keyValue.slice(1).join(':').trim();
      
        // Add the key-value pair to the object
        obj[key] = value;
    });
  
    return obj;
}

function handle_passed_fail(validationObj){
    // Adding or removing of error messages
    if(!validationObj.passed)
        display_error(validationObj)
    else
        remove_display_error(validationObj)
}

function toggle_save($save, valid){
    if(!$save.prop('disabled') && !valid)
        am.$('#js-save-page').prop('disabled', true).addClass('am-btn--disabled');
    else
        am.$('#js-save-page').prop('disabled', false).removeClass('am-btn--disabled');
}

function display_error(validationObj){
    // Add display error dependant on chosen display type
    var br = '';
    var $input = validationObj.input;
    if($input.hasClass('am-error-border'))
        return;

    var $body = am.$('body');
    if($body.hasClass('am-breakpoint-xlarge') || $body.hasClass('am-breakpoint-xxlarge')){
        br = `<br />`;
    }

    if(validationObj.errorType == 'both'){
        $input.addClass('am-error-border').after(`${br}<span class="am-error-text" ><i class="fas fa-exclamation-triangle"></i> ${validationObj.errorMsg} </span>`)
    }else if(validationObj.errorType == 'msg'){
        $input.after(`${br}<span class="am-error-text" >${validationObj.errorMsg}</span>`)
    }else{
        $input.addClass('am-error-border')
    }

    const $save = am.$('#js-save-page');
    if($save.length > 0)
        toggle_save($save, false);
}

function remove_display_error(validationObj){
    // Remove display error
    var $input = validationObj.input;

    if($input.hasClass('am-error-border'))
        $input.removeClass('am-error-border')

    if($input.siblings('span').length > 0 && $input.siblings('span').hasClass('am-error-text'))
        $input.siblings('span').remove();

        const $save = am.$('#js-save-page');
        if($save.length > 0)
            toggle_save($save, true);
}

// ----------------------   specalized validaion functions below   -----------------------------

function isPositive(number) {
    return number > 0;
}

function isNumber(value) {
    return !isNaN(value);
}

function check_text_valid(validationObj){
    var value = validationObj.input.val();

    if(validationObj.regex){
        try{
            var test = value.match(validationObj.regex);
            if(test != null )
                return true;
            else
                return false;

        }catch(e){
            console.log(e)
        }
    }else{
        if(value != '' || value != ' ')
            return true;
        else
            return false;
    }
}

function check_min_length(validationObj){
    if(validationObj.input.val().length >= parseInt(validationObj.minLength))
        return true;
    else
        return false;
}

function decimal_check(val, desiredDecimalPlaces = 2){
    const limitedNumber = Number(val).toFixed(desiredDecimalPlaces);

    return limitedNumber;
}